export default function() {}



//////////////////
// WEBPACK FOOTER
// ./node_modules/d3-contour/src/noop.js
// module id = 1424
// module chunks = 0